var map = {
	"./add.png": "1d89",
	"./add_o.png": "3b52",
	"./close.png": "04b3",
	"./default_avatar.png": "d356",
	"./fail.png": "73cf",
	"./hehua.png": "0b7a",
	"./ivon_success.png": "66ca",
	"./listBuildBtn.png": "99c1",
	"./listDonationBtn.png": "15e7",
	"./listWillBtn.png": "f199",
	"./mifeng.png": "8679",
	"./my.png": "4fea",
	"./my_o.png": "7f12",
	"./myorder.png": "49dd",
	"./notice.png": "b852",
	"./orderTip.png": "4fd2",
	"./out.png": "11b8",
	"./points.png": "96d2",
	"./ranks.png": "d805",
	"./reject.png": "0eb5",
	"./returnImg.png": "31a4",
	"./sign.png": "de03",
	"./tip.png": "a736",
	"./volunteer.png": "1564",
	"./waitHandle.png": "ad5d",
	"./waitVerify.png": "4e28"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b9671";